import React from 'react';
import ItemLocationList from './ItemLocationList';

const ItemLocation = () => {
  return (
    <div className="card shadow-lg main-card" style={{ position: 'relative' }}>
      <div className="card-header bg-secondary text-white">
        <h4 className="mb-0 h6 fw-semibold">{"Location Summary"}</h4>
      </div>
      <div className="card-body">
        <ItemLocationList />
      </div>
    </div>
  );
};

export default ItemLocation;
